export const VIDEO_CAMPAIGN_SUPPORT_LINK = 'https://ajuda.wifeed.com.br/pt-BR/articles/8780313-campanha-do-tipo-video';

export const messagesCampaigns = {
    pt: {
        message:{
            addComment: "Adicionar comentário",
            addOption: "Adicionar opção",
            advancedSettings: "Configurações avançadas",
            airingInterval: "Intervalo de Veiculação",
            allDay: "Dia inteiro",
            allTypesOfForms: "Todos os tipos de cadastro",
            and: "e",
            attention: "Atenção!",
            background: "Fundo",
            banner: "Banner",
            border: "Borda",
            button: "BOTÃO",
            button1: "BOTÃO 1",
            button2: "BOTÃO 2",
            buttons: "botões",
            clickToEdit: "Clique para editar",
            campaign: "Campanha",
            campaignName: "Nome da campanha",
            campaignsOrdering: "Ordenação de Campanhas",
            allCampaigns: "Todas as campanhas",
            changeBackgroundImage: "Alterar imagem do celular",
            changeBackgroundImageDesktop: "Alterar imagem do computador",
            changeInteraction: "Alterar Interação",
            changeInteractionType: "Alterar tipo de interação",
            changeInteractionTypeConfirmation: "Ao alterar o tipo de interação você perderá os ajustes de",
            changeInteractionTypeConfirmation2: "cadastrados, deseja continuar?",
            colors: "cores",
            connection: "Conexão",
            coupon: "Cupom",
            createCampaign: "Criar Campanha",
            deleteOption: "Excluir opção",
            design: "Design",
            dropImageHere: "Arraste e solte sua imagem aqui",
            editScreens: "Editar Telas",
            enableGradientColor: "Habilitar cor gradiente",
            enableIntegration: "Habilitar integração",
            everyDay: "Todos os dias",
            everyone: "Todos",
            font: "Fonte",
            friday: "SEX",
            highPriority: "Alta prioridade",
            integration: "Integração",
            interaction: "Interação",
            lastModificationDate: "Data Última Alteração",
            linkIntegration: "Vincular integração",
            lowPriority: "Baixa prioridade",
            mediumPriority: "Média prioridade",
            men: "Homens",
            monday: "SEG",
            multipleChoice: "Múltipla escolha",
            myCampaigns: "Minhas campanhas",
            newScreen: "Nova tela",
            notDeclared: "Não Declarados",
            nps: "NPS",
            oneButton: "1 Botão",
            option: "Opção",
            or: "ou",
            order: "Ordem",
            poll: "Pesquisa",
            postAuthPage: "Página pós-autenticação",
            copyVal: "Valor de cópia",
            defineCopyVal: "Definir valor de cópia",
            removeCampaign: "Remover campanha",
            removeCampaignConfirmation: "Você tem certeza que deseja remover essa campanha?",
            removeImages: "Remover imagens",
            removeImagesAndSelectColor: "Remover imagens e selecionar cor de fundo",
            removeInteraction: "Remover Interação",
            removeInteractionConfirmation: "Você tem certeza que deseja remover essa interação?",
            repeat: "Repetir",
            saturday: "SAB",
            saveEdit: "Salvar Edição",
            saved: "Salvo",
            saving: "Salvando...",
            seeLess: "Ver menos",
            segmentation: "Segmentação",
            selectBackgroundColor: "Selecionar cor de fundo",
            selectFile: "Selecionar arquivo",
            selectImage: "Selecionar imagem",
            selectImageComputer: "Selecionar imagem para computador",
            selectImagePhone: "Selecionar imagem para celular",
            settingsWillBeLost: "Todas as configurações dela serão perdidas.",
            showOnlyToBirthdayPerson: "Mostrar campanha apenas para aniversariantes",
            sunday: "DOM",
            text: "Texto",
            texts: "textos",
            thirdPartyCampaigns: "Campanhas de Terceiros",
            thursday: "QUI",
            tuesday: "TER",
            twoButtons: "2 Botões",
            video: "Vídeo",
            videoWarning: `Para que a campanha de vídeo funcione corretamente, é necessário fazer alguns ajustes técnicos. Por favor, entre em contato com nossa equipe. Ou caso queira ver o artigo, <a href="${VIDEO_CAMPAIGN_SUPPORT_LINK}" target="_blank">clique aqui</>.`,
            wednesday: "QUA",
            women: "Mulheres",
            yearsOld: " anos",
            sendIntegrationAfter: "Enviar integração após o termino do tempo de acesso do cliente",
            previewMobile: 'Visualizar no telefone',
            previewDesktop: 'Visualizar no computador'
        }
    },
    es: {
        message:{
            addComment:"Agregar comentario",
            addOption:"Agregar opción",
            advancedSettings:"Configuraciones avanzadas",
            airingInterval:"Intervalo de transmisión",
            allDay:"Dia entero",
            allTypesOfForms: "Todo tipo de registro",
            and:"y",
            attention: "¡Atención!",
            background:"Fondo",
            banner:"Banner",
            border:"Borde",
            button:"BOTÓN",
            button1:"Botón 1",
            button2:"Botón 2",
            buttons:"botones",
            clickToEdit:"Haz click para editar",
            campaign:"Campaña",
            campaignName:"Nombre de la campaña",
            campaignsOrdering:"Orden de campaña",
            allCampaigns: "Todas las campañas",
            changeBackgroundImage:"Cambiar la imagen del fondo",
            changeBackgroundImageDesktop: "Cambiar la imagen de la computadora",
            changeInteraction:"Cambiar interacción",
            changeInteractionType:"Cambiar tipo de interacción",
            changeInteractionTypeConfirmation:"Al cambiar el tipo de interacción, se perderá los ajustes",
            changeInteractionTypeConfirmation2:"Registrado, ¿quieres continuar?",
            colors:"Colores",
            connection:"Conexión",
            coupon:"Cupón",
            createCampaign:"Crear campaña",
            deleteOption:"Eliminar opción",
            design:"Diseño",
            dropImageHere:"Arrastre y suelte su imagen aquí",
            editScreens:"Editar pantallas",
            enableGradientColor: "Habilitar color degradado",
            enableIntegration:"Habilitar integración",
            everyDay:"Todos los días",
            everyone:"Todos",
            font:"Fuente",
            friday:"VIE",
            highPriority: "Alta prioridad",
            integration:"Integración",
            interaction:"Interacción",
            lastModificationDate:"Fecha de último cambio",
            linkIntegration:"Integración de enlaces",
            lowPriority: "Baja prioridad",
            mediumPriority: "Media prioridad",
            men:"Hombres",
            monday:"LUN",
            multipleChoice:"Opción multiple",
            myCampaigns:"Mis campañas",
            newScreen:"Nueva pantalla",
            notDeclared:"No declarado",
            nps:"NPS",
            oneButton:"1 botón",
            option:"Opción",
            or:"o",
            order:"Ordenar",
            poll:"Buscar",
            postAuthPage:"Página posterior a la autorización",
            copyVal: "Valor a copiar",
            defineCopyVal: "Definir valor a copiar",
            removeCampaign:"Eliminar campaña",
            removeCampaignConfirmation:"¿Estás seguro de que quieres eliminar esta campaña?",
            removeImages: "Eliminar imágenes",
            removeImagesAndSelectColor: "Eliminar imágenes y seleccionar color de fondo",
            removeInteraction:"Eliminar la interacción",
            removeInteractionConfirmation:"¿Estás seguro de que quieres eliminar esta interacción?",
            repeat:"Repetir",
            saturday:"Sab",
            saveEdit:"Guardar edición",
            saved:"Guardado",
            saving:"Guardando...",
            seeLess:"Ver menos",
            segmentation:"Segmentación",
            selectBackgroundColor: "Seleccionar color de fondo",
            selectFile:"Seleccione Archivo",
            selectImage: "Seleccionar imagen",
            selectImageComputer: "Seleccionar imagen para computadora",
            selectImagePhone: "Seleccionar imagen para móvil",
            settingsWillBeLost:"Todas sus configuraciones se perderán",
            showOnlyToBirthdayPerson: "Mostrar campaña solo para cumpleaños",
            sunday:"Dom",
            text:"Texto",
            texts:"textos",
            thirdPartyCampaigns:"Campañas de terceros",
            thursday:"JUE",
            tuesday:"Mar",
            twoButtons:"2 botones",
            video: "Video",
            videoWarning: `Para que la campaña de vídeo funcione correctamente, es necesario realizar algunos ajustes técnicos. Por favor contacte a nuestro equipo. O si quieres ver el artículo haz <a href="${VIDEO_CAMPAIGN_SUPPORT_LINK}" target="_blank"> clic aquí </a>.`,
            wednesday:"Mie",
            women:"Mujeres",
            yearsOld:"años",
            sendIntegrationAfter: "Envíe la integración después de que expire el tiempo de acceso del cliente",
            previewMobile: 'Ver en el teléfono',
            previewDesktop: 'Ver en la computadora'
        }
    },
    en: {
        message:{
            addComment: "Add comment",
            addOption: "Add option",
            advancedSettings: "Advanced settings",
            airingInterval: "Airing Interval",
            allDay: "All day",
            allTypesOfForms: "All types of forms",
            and: "and",
            attention: "Attention!",
            background: "Background",
            banner: "Banner",
            border: "Border",
            button: "BUTTON",
            button1: "BUTTON 1",
            button2: "BUTTON 2",
            buttons: "buttons",
            clickToEdit: "Click to edit",
            campaign: "Campaign",
            campaignName: "Campaign name",
            campaignsOrdering: "Campaigns ordering",
            allCampaigns: "All campaigns",
            changeBackgroundImage: "Change mobile background",
            changeBackgroundImageDesktop: "Change desktop background",
            changeInteraction: "Change Interaction",
            changeInteractionType: "Change interaction type",
            changeInteractionTypeConfirmation: "When changing the type of interaction you will lose the settings of",
            changeInteractionTypeConfirmation2: "registered, do you want to continue?",
            colors: "colors",
            connection: "Connection",
            coupon: "Coupon",
            createCampaign: "Create Campaign",
            deleteOption: "Delete option",
            design: "Design",
            dropImageHere: "Drag and drop your image here",
            editScreens: "Edit Screens",
            enableGradientColor: "Enable gradient color",
            enableIntegration: "Enable integration",
            everyDay: "Every day",
            everyone: "Everyone",
            font: "Font",
            friday: "FRI",
            highPriority: "High priority",
            integration: "Integration",
            interaction: "Interaction",
            linkIntegration: "Link integration",
            lowPriority: "Low priority",
            mediumPriority: "Medium priority",
            lastModificationDate: "Last Modification Date",
            men: "Men",
            monday: "MON",
            multipleChoice: "Multiple choice",
            myCampaigns: "My campaigns",
            newScreen: "New screen",
            notDeclared: "Undeclared",
            nps: "NPS",
            oneButton: "1 Button",
            option: "Option",
            or: "or",
            order: "Order",
            poll: "Poll",
            postAuthPage: "Post-authentication page",
            copyVal: "Value to copy",
            defineCopyVal: "Define value to copy",
            removeCampaign: "Remove campaign",
            removeCampaignConfirmation: "Are you sure you want to remove this campaign?",
            removeImages: "Remove images",
            removeImagesAndSelectColor: "Remove images and select background color",
            removeInteraction: "Remove Interaction",
            removeInteractionConfirmation: "Are you sure you want to remove this interaction?",
            repeat: "Repeat",
            saturday: "SAT",
            saveEdit: "Save Edit",
            saved: "Saved",
            saving: "Saving...",
            seeLess: "See less",
            segmentation: "Segmentation",
            selectBackgroundColor: "Select background color",
            selectFile: "Select file",
            selectImage: "Select image",
            selectImageComputer: "Select desktop image",
            selectImagePhone: "Select mobile image",
            settingsWillBeLost: "All its settings will be lost.",
            showOnlyToBirthdayPerson: "Show campaign only for birthdays",
            sunday: "SUN",
            text: "Text",
            texts: "texts",
            thirdPartyCampaigns: "Campanhas de Terceiros",
            thursday: "THU",
            tuesday: "TUE",
            twoButtons: "2 Buttons",
            video: "Video",
            videoWarning: `For the video campaign to work correctly, you need to make some technical adjustments. Please contact our team. If you want to see the article, <a href="${VIDEO_CAMPAIGN_SUPPORT_LINK}" target="_blank"> click here </a>.`,
            wednesday: "WED",
            women: "Women",
            yearsOld: " years old",
            sendIntegrationAfter: "Do you want to send this integration when the client access ends ?",
            previewMobile: 'Preview on mobile',
            previewDesktop: 'Preview on desktop'
        }
    }
}
